import * as S from "../styles";

interface ProgressStepperProps {
  value: string;
  max: number;
  onChange: (value: string) => void;
  onSave: () => void;
}

const parseValue = (value: string, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const ProgressStepper = ({
  value,
  max,
  onChange,
  onSave,
}: ProgressStepperProps) => {
  const current = parseValue(value, 0);
  const canDecrease = current > 0;
  const canIncrease = current < max;

  const handleDecrease = () => {
    onChange(String(Math.max(0, current - 1)));
  };

  const handleIncrease = () => {
    onChange(String(Math.min(max, current + 1)));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;
    if (next === "") {
      onChange("");
      return;
    }
    if (!/^\d+$/.test(next)) return;
    const num = Number(next);
    onChange(String(Math.min(max, num)));
  };

  const handleBlur = () => {
    if (value === "") {
      onChange("0");
      return;
    }
    onChange(String(Math.min(max, Math.max(0, parseValue(value, 0)))));
  };

  return (
    <S.ProgressControls>
      <S.ProgressStepper>
        <S.StepperButton
          type="button"
          onClick={handleDecrease}
          disabled={!canDecrease}
          aria-label="진행도 감소"
        >
          −
        </S.StepperButton>
        <S.StepperInput
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          inputMode="numeric"
        />
        <S.StepperButton
          type="button"
          onClick={handleIncrease}
          disabled={!canIncrease}
          aria-label="진행도 증가"
        >
          +
        </S.StepperButton>
      </S.ProgressStepper>
      <S.GrayButton type="button" onClick={onSave}>
        저장
      </S.GrayButton>
    </S.ProgressControls>
  );
};

export default ProgressStepper;
